import http from './public'

// 验证手机号是否注册
export const validateMobile = (mobile) => {
  return http._get(`/api/public/member/validateMobile/${mobile}`)
}

// 获取手机验证码
export const getRegCode = (mobile, isExist) => {
  return http._get(`/api/public/member/getRegCode/${mobile}/${isExist}`)
}

// 校验手机验证码
export const validateRegCode = (mobile, code) => {
  return http._get(`/api/public/member/validateRegCode/${mobile}/${code}`)
}

// 用户注册
export const userReg = (params) => {
  return http.post('/api/public/member/userReg', params)
}

// 重置用户密码
export const resetPassword = (params) => {
  return http.post('/api/public/member/resetPassword', params)
}

// 用户登录
export const userLogin = (params) => {
  return http.post('/api/public/member/userLogin', params)
}

// 获取店铺中的商品
export const getGoodsList = (params) => {
  return http.post('/api/public/product/getGoodsList', params)
}

// 获取商品同类推荐
export const getTopGoods = (goodsUUID, UserUUID) => {
  return http._get(`/api/public/product/getTop_Goods/${goodsUUID}/${UserUUID || 'null'}`)
}

// 获取店铺商品明细
export const getGoodsDetail = (goodsUUID, UserUUID) => {
  return http._get(`/api/public/product/getGoodsDetail/${goodsUUID}/${UserUUID || 'null'}`)
}

// 保存购物车
export const saveCart = (params) => {
  return http.post('/api/store/cart/saveCart', params)
}

// 获取购物车
export const getCart = (userUUID) => {
  return http._get(`/api/store/cart/getCart/${userUUID}`)
}

// 获取国家列表
export const getCountryList = () => {
  return http._get('/api/public/area/getCountryList')
}

// 获取省列表
export const getStateList = (countryID) => {
  return http._get(`/api/public/area/getStateList/${countryID}`)
}

// 获取城市列表
export const getCityList = (stateID) => {
  return http._get(`/api/public/area/getCityList/${stateID}`)
}

// 获取区县列表
export const getDistrictList = (cityID) => {
  return http._get(`/api/public/area/getDistrictList/${cityID}`)
}

// 修改用户信息
export const saveUser = (params) => {
  return http.post('/api/store/member/saveUser', params)
}

// 获取用户信息
export const getUserDetail = (userUUID) => {
  return http._get(`/api/store/member/getUserDetail/${userUUID}`)
}

// 新增/修改收货地址
export const saveAddress = (params) => {
  return http.post('/api/store/member/saveAddress', params)
}

// 设置默认收货地址
export const setAddressDefault = (params) => {
  return http.post('/api/store/member/setAddressDefault', params)
}

// 获取收货地址列表
export const getAddressList = (userUUID, search) => {
  return http._get(`/api/store/member/getAddressList/${userUUID}/${search}`)
}

// 选择收货地址列表
export const selectAddressList = (userUUID, search) => {
  return http._get(`/api/store/member/selectAddressList/${userUUID}/${search}`)
}

// 获取收货地址详细
export const getAddressDetail = (addressUUID) => {
  return http._get(`/api/store/member/getAddressDetail/${addressUUID}`)
}

// 删除收货地址
export const deleteAddress = (userUUID, addressUUID) => {
  return http._delete(`/api/store/member/deleteAddress/${userUUID}/${addressUUID}`)
}

// 用户网上下单
export const saveOrder = (params) => {
  return http.post('/api/store/order/saveOrder', params)
}

// 获取店铺参数明细
export const getShopParam = () => {
  return http._get('/api/public/param/getShopParam')
}

// 获取订单列表
export const getOrderList = (params) => {
  return http.post('/api/store/order/getOrderList', params)
}

// 获取订单详细信息
export const getOrderDetail = (orderUUID) => {
  return http._get(`/api/store/order/getOrderDetail/${orderUUID}`)
}

// 获取订单支付信息
export const getOrderDetailPay = (bh) => {
  return http._get(`/api/store/order/getOrderDetail_Pay/${bh}`)
}

// 获取订单日志信息
export const getOrderDetailLog = (bh) => {
  return http._get(`/api/store/order/getOrderDetail_Log/${bh}`)
}

// 获取订单出库信息
export const getOrderDetailCkd = (bh) => {
  return http._get(`/api/store/order/getOrderDetail_Ckd/${bh}`)
}

// 取消订单
export const cancelOrder = (orderUUID, bh, updatedAt) => {
  return http._post(`/api/store/order/cancelOrder/${orderUUID}/${bh}/${updatedAt}`)
}

// 确认订单
export const agreeOrder = (orderUUID, bh, updatedAt) => {
  return http._post(`/api/store/order/agreeOrder/${orderUUID}/${bh}/${updatedAt}`)
}

// 删除订单
export const deleteOrder = (orderUUID, bh, updatedAt) => {
  return http._delete(`/api/store/order/deleteOrder/${orderUUID}/${bh}/${updatedAt}`)
}

// 订单确认收货
export const confirmOrder = (orderUUID, bh, updatedAt) => {
  return http._post(`/api/store/order/confirmOrder/${orderUUID}/${bh}/${updatedAt}`)
}

// 订单退款申请
export const refundApply = (params) => {
  return http.post('/api/store/order/refundApply', params)
}

// 填写订单退货物流信息
export const refundPsdBH = (params) => {
  return http.post('/api/store/order/refundPsdBH', params)
}

// 获取店铺销售的商品SKU
export const getGoodsSkuList = (params) => {
  return http.post('/api/store/product/getGoodsSkuList', params)
}

// 获取店铺销售的商品SKU EXCEL
export const getGoodsSkuExcle = (params) => {
  return http.post('/api/store/product/getGoodsSkuExcle', params)
}

// 选择店铺中的商品大类
export const selectShopCpDlList = (search) => {
  return http._get(`/api/public/product/selectShopCpDlList/${search}`)
}

// 选择店铺中的商品类别
export const selectShopCpLbList = (cpDl, search) => {
  return http._get(`/api/public/product/selectShopCpLbList/${cpDl}/${search}`)
}

// 选择店铺中的商品品牌
export const selectShopCpTmList = (cpDl, cpLb, search) => {
  return http._get(`/api/public/product/selectShopCpTmList/${cpDl}/${cpLb}/${search}`)
}

// 选择店铺中的商品系列
export const selectShopCpXlList = (cpDl, cpLb, cpTm, search) => {
  return http._get(`/api/public/product/selectShopCpXlList/${cpDl}/${cpLb}/${cpTm}/${search}`)
}

// 选择银行账户列表
export const selectBankList = (search) => {
  return http._get(`/api/store/bas/selectBankList/${search}`)
}

// 选择货运公司列表
export const selectForwarderList = (search) => {
  return http._get(`/api/store/bas/selectForwarderList/${search}`)
}

// 获取银行账户信息
export const getBankDetail = (bankID) => {
  return http._get(`/api/store/bas/getBankDetail/${bankID}`)
}

// 订单电汇付款
export const payBankOrder = (params) => {
  return http.post('/api/store/order/payBankOrder', params)
}

// 在线支付
export const payOrder = (params) => {
  return http.post('/api/store/order/payOrder', params)
}

// 上传用户头像
export const uploadUserFaceImg = (params) => {
  return http.post('/api/store/member/uploadUserFaceImg', params)
}

// 获取首页配置
export const getHome = () => {
  return http._get('/api/public/param/getHome')
}

// 选择店铺中的商品大类、类别
export const selectShopCpDlLbList = () => {
  return http._get('/api/public/product/selectShopCpDlLbList')
}

// 获取首页商品按分组
export const getHomeGoods = (id, UserUUID) => {
  return http._get(`/api/public/param/getHome_Goods/${id}/${UserUUID || 'null'}`)
}

// 获取收款单列表
export const getSkdList = (params) => {
  return http.post('/api/store/ckd/getSkdList', params)
}

// 获取收款单详细信息
export const getSkdDetail = (bh) => {
  return http._get(`/api/store/ckd/getSkdDetail/${bh}`)
}

// 获取出库单列表
export const getCkdList = (params) => {
  return http.post('/api/store/ckd/getCkdList', params)
}

// 获取出库单详细信息
export const getCkdDetail = (bh) => {
  return http._get(`/api/store/ckd/getCkdDetail/${bh}`)
}

// 获取出库单商品明细
export const getCkdDetailCkdB = (bh) => {
  return http._get(`/api/store/ckd/getCkdDetail_CkdB/${bh}`)
}

// 获取出库单开票列表
export const getCkdKpList = (params) => {
  return http.post('/api/store/ckd/getCkdKpList', params)
}

// 获取往来账列表
export const getHisAccList = (params) => {
  return http.post('/api/store/ckd/getHisAccList', params)
}

// 出库单取消
export const ckdUd = (params) => {
  return http.post('/api/store/ckd/ckdUd', params)
}

// 选择商品大类(全部)
export const selectCpDlList = (search) => {
  return http._get(`/api/store/product/selectCpDlList/${search}`)
}

// 选择商品类别(全部)
export const selectCpLbList = (cpDl, search) => {
  return http._get(`/api/store/product/selectCpLbList/${cpDl}/${search}`)
}

// 选择商品品牌(全部)
export const selectCpTmList = (cpDl, cpLb, search) => {
  return http._get(`/api/store/product/selectCpTmList/${cpDl}/${cpLb}/${search}`)
}

// 选择商品系列(全部)
export const selectCpXlList = (cpDl, cpLb, cpTm, search) => {
  return http._get(`/api/store/product/selectCpXlList/${cpDl}/${cpLb}/${cpTm}/${search}`)
}

// 获取出库商品
export const getCkdCpList = (params) => {
  return http.post('/api/store/ckd/getCkdCpList', params)
}

// 获取出库商品系列号
export const getCkdCpPhList = (params) => {
  return http.post('/api/store/ckd/getCkdCpPhList', params)
}

// 获取销售返款科目列表
export const getXsReturnKmList = (dwID) => {
  return http._get(`api/store/ckd/getXsReturnKmList/${dwID}`)
}

// 获取销售返款历史列表
export const getXsReturnHisList = (params) => {
  return http.post('/api/store/ckd/getXsReturnHisList', params)
}

// 修改用户密码
export const changePassword = (params) => {
  return http.post('/api/store/member/changePassword', params)
}

// 修改用户手机号
export const changeMobile = (params) => {
  return http.post('/api/store/member/changeMobile', params)
}

// 获取页尾分类列表
export const getFooterColumnList = () => {
  return http._get('api/public/param/getFooterColumnList/null')
}

// 获取页尾明细列表
export const getFooterColumnDetailList = (columnID) => {
  return http._get(`api/public/param/getFooterColumnDetailList/${columnID}/null`)
}

// 获取商城通知列表
export const getNoticeList = () => {
  return http._get('api/public/param/getNoticeList/null')
}

// 获取商城热词列表
export const getHotwordList = () => {
  return http._get('api/public/param/getHotwordList/null')
}

// 获取页尾明细按ID
export const getFooterColumnDetailByID = (id) => {
  return http._get(`api/public/param/getFooterColumnDetailByID/${id}`)
}
// 获取商城通知按ID
export const getNoticeByID = (id) => {
  return http._get(`api/public/param/getNoticeByID/${id}`)
}



// WEBPACK FOOTER //
// ./src/api/index.js